import {
  BaSeButton,
  BaSeHeading6,
  BaSeParagraph,
  BaSeTextArea,
  BaSeTheme,
} from '@base/react';
import React, { useState } from 'react';

import { useMessage } from '../../../../../../hooks/messages/useMessage';
import { useInterviewService } from '../../../../../../hooks/services/interview-service';
import { AlignButtons, Container } from './delete-certification-style';

const wordSeparatorRegEx =
  /(!([^\s0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+|\s|[-–@.,][^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w])+/gim;

const clearValueToFilterWord = (value = '') => {
  return value
    .trim()
    .replace(/^[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+/gim, '')
    .replace(/[^0-9À-ÿa-zA-zÀ-ÖØ-öø-ÿ\w]+$/gim, '');
};

function DeleteCertificate({ values, closeModal, reloadData }) {
  const { deleteCertificate } = useInterviewService();
  const { handleError, handleSuccess } = useMessage();

  const [text, setText] = useState('');

  const wordCounter = React.useCallback((value) => {
    const cleanValue = clearValueToFilterWord(value);
    if (cleanValue.length === 0) {
      setText('');
      return 0;
    }
    const splittedValue = cleanValue.split(wordSeparatorRegEx);
    const filteredVaue = splittedValue.filter(
      (val) => !!clearValueToFilterWord(val),
    );
    const { length } = filteredVaue;
    if (length === 0) return;
    setText(value);
    return length;
  }, []);

  const countCaracteresBool = React.useCallback((value = '') => {
    const tamanho = value.length;
    const boolValue = tamanho >= 20 && tamanho <= 100 ? true : false;
    return !boolValue;
  }, []);

  const handleDeletCertificate = React.useCallback(async () => {
    deleteCertificate(values.id, text)
      .then(() => {
        handleSuccess('Certificado do candidato excluído com sucesso!');
        closeModal();
        reloadData();
      })
      .catch(({ message }) => {
        handleError(message);
      });
  }, [
    deleteCertificate,
    values,
    text,
    handleSuccess,
    closeModal,
    reloadData,
    handleError,
  ]);

  return (
    <Container>
      <BaSeHeading6 color={BaSeTheme.colors.feedbackInterface.atencao55} isBold>
        Atenção!
      </BaSeHeading6>

      <div>
        <BaSeParagraph>
          Tem certeza que deseja excluir o certificado do(a) candidato(a){' '}
          <strong>{values.candidate.name}</strong>?
        </BaSeParagraph>
      </div>

      <div>
        <BaSeParagraph>
          Ao realizar a exclusão do certificado do(a) candidato(a), os dados do
          certificado do(a) candidato(a) são excluídos e o status de sua
          entrevista retorna para <strong>"Finalizada"</strong>.
        </BaSeParagraph>
      </div>

      <div>
        <BaSeParagraph>Motivo da Exclusão:</BaSeParagraph>
        <BaSeTextArea
          hasCounter="chars"
          placeholder="Descreva o motivo para a exclusão do certificado."
          complement="Mínimo 20 caracteres"
          onChange={(value) => {
            wordCounter(value);
          }}
          rows={2}
          textError={'erro'}
          textSize="medium"
          value={text}
          maxLength={100}
          counterMinLength={20}
          counterMaxLength={100}
        />
      </div>
      <AlignButtons>
        <BaSeButton
          value="Excluir"
          isDisabled={countCaracteresBool(text)}
          onClick={handleDeletCertificate}
          color={BaSeTheme.colors.defaultColors.black}
        />
        <BaSeButton
          value="Cancelar"
          type="secondary"
          color={BaSeTheme.colors.defaultColors.black}
          onClick={() => closeModal()}
        />
      </AlignButtons>
    </Container>
  );
}

export default DeleteCertificate;
